import { AutoMap } from "@automapper/classes"
import { ZoneMeasureDTO } from "./zone-measure.dto"
import { PortfolioDTO } from "./portfolio.dto"
import { WorkDTO } from "./work.dto"

export class StrategyDTO {

    @AutoMap()
    id!: number
    @AutoMap()
    type!: number
    @AutoMap()
    eLimsStrategyCode!: string
    @AutoMap()
    contexteHorsStrategie!: boolean
    @AutoMap()
    portfolio!: PortfolioDTO
    @AutoMap()
    upcomingAVT!: string;
}